<template>
    <div class="flex flex-col">
        <div class="relative z-0 w-full px-10">
            <div class="absolute inset-x-0 top-0 z-0 bg-wecare-red" style="height: 400px;"></div>

            <div class="relative z-10 flex flex-col flex-1 w-full mx-auto bg-white border border-gray-600 my-12 p-10 login-form rounded-lg" style="max-width: 1100px; border-color: rgb(216, 221, 228);">
                <form class="flex flex-col w-full mx-auto text-center" style="max-width: 900px;" data-netlify="true" name="contact" @submit.prevent="submitForm">    
                    <img src="@/assets/img/ask.svg" class="w-auto hidden sm:block sm:h-24" />
                    <span class="font-bold text-2xl md:text-4xl" style="margin-top: 0.4rem;">Nous <span class="text-wecare-red">contacter</span></span>
                    
                    <div class="my-3 border-t border-gray-600 w-full"></div>

                    <div v-if="!isSent" class="flex flex-col">
                        <span class="mx-auto text-center mt-5 mb-2 font-medium text-gray-700 text-lg">Toute l’équipe WeCare se mobilise pour vous !</span>
                        <aff-input  v-model="email" label="Votre e-mail" placeholder="E-mail" type="text" :errors="errors && errors.email ? errors.email : null" class="w-full" />
                        <textarea v-model="message" class="w-full bg-gray-100 outline-none border border-gray-500 rounded p-3" name="texte" id="" cols="30" rows="10" placeholder="Un renseignement ? Ou besoin d’aide ? Décrivez-nous ici votre demande en précisant votre numéro d’adhérent WeCare et votre email. Nous vous repondrons par email dans le plus brefs délais."></textarea>
                        
                        <span class="mt-1 md:mt-2 mb-3 text-sm md:text-base md:font-bold text-left" style="color: #f84036">
                            <span class="block" v-if="errors && errors.message">
                                <span>{{ errors.message[0] }}</span>
                            </span>
                        </span>

                        <input type="submit" class="btn h-20 cursor-pointer border border-wecare-red bg-wecare-red hover:scale-105 hover:bg-white hover:text-wecare-red" value="Envoyer" v-if="!isLoading" />

                        <span class="btn h-20 bg-wecare-red cursor-wait" v-else>
                            <svg version="1.1" class="text-white fill-current" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                                <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(19.7256 25 25)">
                                    <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
                                </path>
                            </svg>
                        </span>
                    </div>

                    <div v-else>
                        <span class="text-center py-32 flex justify-center w-full text-green-500">Message envoyé.</span>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import AffInput from '@/components/forms/Input'

export default {
    components: { AffInput },
    data: function () {
        return {
            isLoading: false,
            isSent: false,
            email: null,
            errors: null,
            message: null
        }
    },
    methods: {
        submitForm () {
            this.isLoading = true
            axios.post(process.env.VUE_APP_API_BASE_URL + 'wecare_plus/contact', {
                email: this.email,
                message: this.message
            })
            .then(() => {
                this.isSent = true
                this.errors = null
            },
            (response) => {
                this.errors = response.response.data.errors
                this.isLoading = false
            })
        }
    }
}
</script>